/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ClearanceCaseFilterStatus {
  Registered = 0,
  Waiting = 1,
  Processing = 2,
  Complete = 3,
}
